import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { useI18n } from "./I18nContext";
import { fmtMoney, sportById } from "../lib/sports";

const Ctx = createContext(null);

export function SiteProvider({ children }) {
  const { lang } = useI18n();
  const [cur, setCurState] = useState(() => localStorage.getItem("currency") || "USD");
  const [settings, setSettings] = useState(null);
  useEffect(() => { api.get("/public/settings").then(({ data }) => setSettings(data)).catch(() => {}); }, []);
  const setCur = (c) => { localStorage.setItem("currency", c); setCurState(c); };
  const L = (en, bg) => (lang === "bg" ? bg : en);
  const rate = settings?.eur_per_usd || 0.92;
  const convert = (amount, from) => {
    const f = (from || "USD").toUpperCase();
    if (f === cur) return amount;
    return f === "USD" ? amount * rate : amount / rate;
  };
  // Display in the visitor's currency; "≈" marks a converted estimate (charged in the coach's currency).
  const price = (amount, from) => {
    const f = (from || "USD").toUpperCase();
    const v = convert(Number(amount || 0), f);
    return `${f === cur ? "" : "≈"}${fmtMoney(Math.round(v), cur)}`;
  };
  const sportLabel = (id) => { const s = sportById(id); return s ? (lang === "bg" ? s.bg : s.en) : id; };
  const enabledSports = (settings?.sports || []).filter((s) => s.enabled).map((s) => s.id);
  return (
    <Ctx.Provider value={{ lang, cur, setCur, settings, L, price, convert, sportLabel, enabledSports }}>
      {children}
    </Ctx.Provider>
  );
}

export const useSite = () => useContext(Ctx);
